const STOP_WORDS = new Set([
  'alors', 'ainsi', 'avec', 'avoir', 'comme', 'dans', 'donc', 'elle', 'elles', 'entre',
  'etre', 'fait', 'faire', 'faut', 'hors', 'leur', 'leurs', 'mais', 'meme', 'pour',
  'puis', 'quand', 'quoi', 'sans', 'sont', 'tout', 'tres', 'vers', 'zone', 'cette',
  'cela', 'plus', 'moins', 'sur', 'aux', 'des', 'les', 'une', 'que', 'qui', 'est',
  'par', 'pas', 'du', 'de', 'la', 'le', 'un', 'en', 'et', 'ou', 'au', 'il'
]);

const TACTICAL_KEYWORDS = [
  'appel', 'bloc', 'but', 'centre', 'contre', 'couloir', 'decrochage', 'defense',
  'demarquage', 'duel', 'espace', 'fixation', 'frappe', 'largeur', 'ligne',
  'marquage', 'passe', 'pressing', 'projection', 'profondeur', 'repli', 'surnombre',
  'temporisation', 'transition', 'tir', 'triangle', 'unedeux'
];

export function normalizeText(value = '') {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/1-2|une-deux|une deux/g, ' unedeux ')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function tokenizeAnalysis(value = '') {
  return normalizeText(value)
    .split(' ')
    .filter((token) => token.length >= 3 && !STOP_WORDS.has(token));
}

export function extractTacticalKeywords(value = '') {
  const normalized = ` ${normalizeText(value)} `;
  return TACTICAL_KEYWORDS.filter((keyword) => normalized.includes(` ${keyword} `));
}

export function scoreQuizAnswer(userAnswer = '', aiAnswer = '') {
  const userText = normalizeText(userAnswer);
  const aiText = normalizeText(answerToText(aiAnswer));
  if (!userText || !aiText) {
    return {
      score: 0,
      tokenOverlapPct: 0,
      matchedKeywords: [],
      missingKeywords: extractTacticalKeywords(aiText),
      verdict: tr('Analyse insuffisante', 'Insufficient analysis')
    };
  }

  const userTokens = new Set(tokenizeAnalysis(userText));
  const aiTokens = new Set(tokenizeAnalysis(aiText));
  const shared = [...aiTokens].filter((token) => userTokens.has(token));
  const tokenOverlapPct = aiTokens.size ? shared.length / aiTokens.size : 0;

  const userKeywords = extractTacticalKeywords(userText);
  const aiKeywords = extractTacticalKeywords(aiText);
  const matchedKeywords = aiKeywords.filter((keyword) => userKeywords.includes(keyword));
  const missingKeywords = aiKeywords.filter((keyword) => !userKeywords.includes(keyword)).slice(0, 8);
  const keywordOverlapPct = aiKeywords.length ? matchedKeywords.length / aiKeywords.length : tokenOverlapPct;

  const wordCount = userText.split(' ').filter(Boolean).length;
  const detailScore = Math.min(1, wordCount / 45);
  const structureScore = /possession|espace|pressing|transition|decision|tir|passe|but/.test(userText) ? 1 : 0.45;

  const score = Math.round(
    tokenOverlapPct * 45 +
    keywordOverlapPct * 40 +
    detailScore * 10 +
    structureScore * 5
  );

  return {
    score: Math.max(0, Math.min(100, score)),
    tokenOverlapPct: Math.round(tokenOverlapPct * 100),
    matchedKeywords,
    missingKeywords,
    verdict: score >= 75
      ? tr('Très proche', 'Very close')
      : score >= 50
        ? tr('Solide', 'Solid')
        : score >= 30
          ? tr('Partiel', 'Partial')
          : tr('À retravailler', 'Needs work')
  };
}

function answerToText(answer) {
  if (!answer) return '';
  if (typeof answer === 'string') return answer;
  return [
    answer.title,
    answer.summary,
    answer.key_moment,
    answer.interpretation,
    ...(Array.isArray(answer.tactical_elements) ? answer.tactical_elements : [])
  ].filter(Boolean).join(' ');
}
import { tr } from '../services/i18n.js';
